// @flow

import common from './locales/he/common.json'

export const he = { common }

export default he
